import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CustomFilter, FilterComponent } from '../../models';
import { CustomFilterDirective } from '../../directives/custom-filter.directive';

@Component({
  selector: 'mmg-custom-filter',
  templateUrl: './custom-filter.component.html',
  styleUrls: ['./custom-filter.component.scss']
})
export class CustomFilterComponent implements OnInit {
  @Input() filter?: CustomFilter;

  @ViewChild(CustomFilterDirective, {static: true}) customFilter!: CustomFilterDirective;

  ngOnInit(): void {
    if (!!this.filter) {
      const viewContainerRef = this.customFilter.viewContainerRef;
      viewContainerRef.clear();
  
      const componentRef = viewContainerRef.createComponent<FilterComponent>(this.filter.component);
      componentRef.instance.data = this.filter.data;
    }
  }

}